import { Box } from '@mui/material';
import { useState } from 'react';
import { AddButton } from '../../components/common/button/CustomButtons';
import ModalCustom from '../../components/common/Modal';
import ChildHeader from '../../components/ui/ChildHeader';
import { useAuth } from '../../services/auth/AuthProvider';
import CreateCustomerStandard from './components/CreateCustomerStandard';
import CustomerStandardTable from './components/CustomerStandardTable';
import ViewFile from './components/ViewFile';

const CustomerStandardList = () => {
  const { state } = useAuth();
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [id, setId] = useState<string | null>(null);
  const [isFileOpenPopup, setIsFileOpenPopup] = useState(false);

  return (
    <Box>
      <ChildHeader text={"CUSTOMER STANDARDS MODULE"}>
        {state.user?.userType === 2 && (
          <AddButton
            label="NEW CUSTOMER STANDARDS"
            onClick={() => setIsOpenPopup(true)}
          />
        )}
      </ChildHeader>
      <CustomerStandardTable
        {...{ isOpenPopup, setIsFileOpenPopup, setIsOpenPopup, setId }}
      />
      <ModalCustom
        title="CREATE NEW CUSTOMER STANDARDS"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
          setId(null);
        }}
      >
        <CreateCustomerStandard {...{ id, setId, setIsOpenPopup }} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isFileOpenPopup}
        closeModal={() => {
          setId(null);
          setIsFileOpenPopup(false);
        }}
      >
        <ViewFile id={id} />
      </ModalCustom>
    </Box>
  );
};

export default CustomerStandardList;
